import { useEffect, useState } from "react";
import {
    useDebatesStatusStore,
    useSubworkspaceStore,
} from "../../Context/store";
import { useSignalR } from "../../hooks/useSignalR";
import AccordionNav from "../Sidebar/AccordionNav";

const WorkspaceFeedbar = ({
  selectedWorkspace,
  loggedInUser,
  pathname,
  currentPlan,
}) => {
  const [open, setOpen] = useState(0);

  const handleOpen = (update) => {
    setOpen(open === update ? 0 : update);
  };

  const { selectedSubWorkspace } = useSubworkspaceStore();

  const { allForumStatus, handleNewDebateData } = useDebatesStatusStore();
  const { onReceive, offReceive } = useSignalR();

  // update read status
  useEffect(() => {
    onReceive("ReceiveNewDebate", (data) => {
      if (!selectedSubWorkspace?.subWorkSpaceId) console.log("no subworkspace");
      handleNewDebateData(data, selectedSubWorkspace?.subWorkSpaceId);
    });

    onReceive("UnreadDebates", (data) => {
      if (data?.userId === loggedInUser?.userId) {
        if (!selectedSubWorkspace?.subWorkSpaceId) {
          return;
        }
        handleNewDebateData(data, selectedSubWorkspace?.subWorkSpaceId);
      }
      // Handle the new debate data as needed
    });

    return () => {
      offReceive("ReceiveNewDebate");
      offReceive("UnreadDebates");
    };
  }, [onReceive, offReceive, handleNewDebateData]);

  // open Options
  useEffect(() => {
    const path = pathname.slice(1).split("/")[0];
    if (path === "debated") {
      setOpen("debated");
    } else if (path === "voted") {
      setOpen("voted");
    } else if (path === "private") {
      setOpen("private");
    } else if (path === "messageOption") {
      setOpen("message");
    } else if (path === "debated-public") {
      setOpen("public-debated");
    } else if (path === "voted-public") {
      setOpen("public-voted");
    } else {
      setOpen(0);
    }
  }, [pathname]);

  const PublicFeedBarOptions = [
    {
      option: "Public Debates",
      subOption: [],
      route: "/feed-public",
      name: "public-feed",
      hasAccess: true,
      hasRead: allForumStatus?.publicFeed,
    },
    {
      option: "Reference",
      subOption: [],
      route: "/reference",
      name: "reference",
      hasAccess: selectedWorkspace?.referenceAvailable || false,
    },
    // {
    //   option: "News",
    //   subOption: [],
    //   route: "/news",
    //   name: "news",
    //   hasAccess: currentPlan?.accessNews,
    // },
    // {
    //   option: "Motions",
    //   route: "/findMotion",
    //   name: "motions",
    //   hasAccess: currentPlan?.findMotion,
    // },
  ];
  return (
    <div>
      {PublicFeedBarOptions.length > 0 ? (
        <AccordionNav
          open={open}
          pathname={pathname}
          Options={PublicFeedBarOptions}
          handleClose={() => {}}
          handleOpen={handleOpen}
          loggedInUser={loggedInUser}
        />
      ) : null}
    </div>
  );
};

export default WorkspaceFeedbar;
